// extracted by mini-css-extract-plugin
module.exports = {"card":"CardFeatured_card__y7MCx","card__content":"CardFeatured_card__content__V1ZrU","card__title":"CardFeatured_card__title__+nNwk","card__desc":"CardFeatured_card__desc__IzeBh"};